<template>
  <el-dialog
    title="上传航线"
    :close-on-click-modal="false"
    :visible.sync="dialogVisiable"
    :append-to-body="true"
    @close="hide"
    custom-class="routePlanningNameSetContainer"
    width="271px"
  >
    <div class="dataContainer">
      <div class="separator"></div>
      <div class="formContainer">
        <el-form
          :rules="rules"
          :model="commonForm"
          ref="commonForm"
          class="nameSetForm"
          label-width="0px"
        >
          <el-form-item prop="name">
            <el-input
              v-model="commonForm.name"
              placeholder="请输入航线名"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="btnInfoContainer">
        <div class="btn" @click="uploadAirline">确定</div>
        <div class="btn" @click="hide">取消</div>
      </div>
    </div>
  </el-dialog>
</template>

<script type="text/javascript">
export default {
  name: "RoutePlanningNameSet",
  data() {
    return {
      dialogVisiable: false,
      commonForm: { name: "" },
      rules: { name: [{ required: true, message: "请输入航线名称~", trigger: "blur" }] },
    };
  },
  props: ["showNameSet"],
  methods: {
    uploadAirline() {
      this.$refs.commonForm.validate((valid) => {
        if (valid) {
          this.$emit("doUploadAirline", this.$data.commonForm.name);
        }
      });
    },
    hide() {
      this.$emit("changeNameSetStatus", false);
    },
    setName(name) {
      if (!this.isEmptyStr(name)) {
        this.$data.commonForm.name = name;
      }
    },
  },
  watch: {
    showNameSet: function (nval, oval) {
      if (nval) {
        this.$data.dialogVisiable = true;
      } else {
        this.$data.dialogVisiable = false;
      }
    },
  },
};
</script>
<style scoped>
@import "../../../assets/css/mapCss/routePlanningNameSet.css";
</style>
<style>
.routePlanningNameSetContainer {
  height: 146px !important;
  background: rgba(28, 35, 64, 0.9);
  border: 1px solid #0083fd;
  border-radius: 6px;
  margin-top: calc(25% - 73px) !important;
}

.routePlanningNameSetContainer .el-dialog__header {
  height: 18px;
  font-size: 18px;
  font-family: AlibabaPuHuiTiM;
  font-weight: 500;
  padding-top: 13px;
  padding-left: 17px;
  padding-bottom: 13px;
}

.routePlanningNameSetContainer .el-dialog__header .el-dialog__title {
  height: 18px;
  color: #ffffff;
  line-height: 18px;
  float: left;
}

.routePlanningNameSetContainer .el-dialog__header .el-dialog__headerbtn {
  position: absolute;
  right: 16px;
  top: 18px;
}
.routePlanningNameSetContainer .el-dialog__header .el-icon-close {
  color: #ffffff;
}
.routePlanningNameSetContainer .el-dialog__header .el-icon-close:hover {
  color: #0083fd;
}
.routePlanningNameSetContainer .el-dialog__body {
  padding: 0px 16px 22px 18px;
}

.routePlanningNameSetContainer .el-input__inner {
  width: 238px !important;
  height: 34px !important;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
  font-size: 12px;
  font-family: SimSun;
  font-weight: 400;
  color: #fefefe;
  line-height: 34px;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/home/taskplan/RoutePlanningNameSet.vue